const CartRecommendations = {
  swiper: null,

  initSwiper() {
    const swiperElement = document.querySelector('.pf-nst011-collections--slider');
    if (!swiperElement) return;
    
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
    
    loadAssets(['swiper.css', 'swiper.js']).then(() => {
      this.swiper = new MinimogLibs.Swiper('.pf-nst011-collections--slider', {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
        speed: 500,
        on: {
          init: function () {
            CartRecommendations.updateProgressBar(this);
          },
          slideChange: function () {
            CartRecommendations.updateProgressBar(this);
          },
        }
      });
    }).catch(console.error);
    return this.swiper;
  },

  updateProgressBar(swiperInstance) {
    const progressBar = document.querySelector('.pf-nst011-progress-bar');
    const progressText = document.querySelector('.pf-nst011-progress-text');
    if (!progressBar || !progressText) return;
    
    const totalGroups = 2;
    const currentGroup = Math.floor(swiperInstance.realIndex / 3) + 1;
    progressBar.style.width = `${(currentGroup / totalGroups) * 100}%`;
    progressText.textContent = `${currentGroup} / ${totalGroups}`;
  },

  reinitializeCartFunctionality() {
    this.initSwiper();
    
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    if (typeof window.initializeCart === 'function') {
      window.initializeCart();
    }
    
    const quantitySelectors = document.querySelectorAll('.scd__item-quantity select, .scd__item-quantity input');
    quantitySelectors.forEach(selector => {
      selector.addEventListener('change', function(e) {
        const item = e.target.closest('.scd__item');
        if (item) {
          const variantId = item.getAttribute('data-variant-id');
          const quantity = parseInt(e.target.value, 10);
          
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          })
          .then(response => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      });
    });

    const removeButtons = document.querySelectorAll('.scd__item-remove');
    removeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        const item = e.target.closest('.scd__item');
        if (item) {
          const variantId = item.getAttribute('data-variant-id');
          
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          })
          .then(response => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      });
    });
  },

  async addToCart(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      
      if (response.ok) {
        if (window.MinimogTheme?.Cart) {
          await MinimogTheme.Cart.refreshCart();
          
          const cart = MinimogTheme.Cart.cart;
          
          await MinimogTheme.Cart.renderNewCart();
          
          await Shopify.onItemAdded(cart.items[cart.items.length - 1], true);
          
          this.initSwiper();
        }
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  },

  bindEvents() {
    document.addEventListener('cart:opened', () => {
      this.initSwiper();
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains('scd__wrapper') && !mutation.target.classList.contains('hidden')) {
          this.initSwiper();
        }
      });
    });

    const cartDrawer = document.querySelector('.scd__wrapper');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });

      if (!cartDrawer.classList.contains('hidden')) {
        this.initSwiper();
      }
    }

    const cartContentObserver = new MutationObserver(() => {
      this.initSwiper();
    });

    const cartDrawerContent = document.querySelector('.scd__body');
    if (cartDrawerContent) {
      cartContentObserver.observe(cartDrawerContent, {
        childList: true,
        subtree: true
      });
    }

    if (typeof MinimogEvents !== 'undefined') {
      MinimogEvents.subscribe('ON_CART_UPDATE', () => {
        this.initSwiper();
      });
    }

    if (typeof MinimogEvents !== 'undefined') {
      MinimogEvents.subscribe('ON_ITEM_ADDED', () => {
        this.initSwiper();
      });
    }

    document.addEventListener('cart:updated', () => {
      this.initSwiper();
    });

    document.addEventListener('cart:refresh', () => {
      this.initSwiper();
    });

    document.addEventListener('product:added', () => {
      setTimeout(() => this.initSwiper(), 300);
    });

    document.addEventListener('click', (event) => {
      if (event.target.matches('.pf-nst011-add-to-cart')) {
        event.preventDefault();
        event.stopPropagation();
        const variantId = event.target.getAttribute('data-variant-id');
        this.addToCart(variantId);
      }
    });
  },

  init() {
    this.bindEvents();
  }
};
document.addEventListener('DOMContentLoaded', () => {
  CartRecommendations.init();
}); 